
import { Component, Vue} from "vue-property-decorator";

import {
  dispatchGetPhysicalNodesList
} from "@/store/mlm/actions";
import {
  readPhysicalNodesList
} from "@/store/mlm/getters";
import PhysicalNodesPaymentModal from "@/components/Main/Nodes/PhysicalNodesPaymentModal.vue";
@Component({
  components: {
PhysicalNodesPaymentModal
  },
})
export default class PhysicalNodes extends Vue {

  public selectedPhysicalPackage = null
  public showPhysicalNodesPaymentModal = false

    // methods
public handleOpenPhysicalNodesPaymentModal(pack) {
    this.selectedPhysicalPackage = pack;
    this.showPhysicalNodesPaymentModal = true;
  }
    
public async mounted() {
    if(this.physicalNodesList.length == 0){
        await dispatchGetPhysicalNodesList(this.$store)
    }
}

get physicalNodesList() {
    return readPhysicalNodesList(this.$store);
  }


}
